'use client';

import type { CmsLoadedGlobalOverlayState } from './types';

export function CmsOverlayHost({
  open = true,
  overlay,
  onClose,
}: {
  open?: boolean;
  overlay: CmsLoadedGlobalOverlayState | null;
  onClose: () => void;
}) {
  if (!overlay) {
    return null;
  }

  return overlay.runtime.render({ overlay, open, onClose });
}
